var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M40 0.957031C17.92 0.957031 0 18.5745 0 40.2817C0 61.9889 17.92 79.6064 40 79.6064C62.08 79.6064 80 61.9889 80 40.2817C80 18.5745 62.08 0.957031 40 0.957031ZM40 16.6869C47.72 16.6869 54 22.8609 54 30.4505C54 38.0402 47.72 44.2142 40 44.2142C32.28 44.2142 26 38.0402 26 30.4505C26 22.8609 32.28 16.6869 40 16.6869ZM40 71.7414C31.88 71.7414 22.28 68.5168 15.44 60.4159C22.2 55.2251 30.72 52.0791 40 52.0791C49.28 52.0791 57.8 55.2251 64.56 60.4159C57.72 68.5168 48.12 71.7414 40 71.7414Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.583bb1ec6aa8f7638ee01916ca1ab834.svg";
export { ForwardRef as ReactComponent };